// extracted by mini-css-extract-plugin
export default {"card":"cards-list_card__2LWif","header":"cards-list_header__1dARC"};